@let learningPackageHistoryData = learningPackageHistoryData$ | async;
@let timePeriodMode = timePeriodMode$ | async;
@let isAdmin = roleService.assertAdmin() | async;
@let studyProgress = insightPopupService.studyProgresses$ | async;

@if (learningPackageHistoryData !== undefined && learningPackageHistoryData !== null) {
    <div class="mm-learning-progress-history">
        <div class="mm-learning-progress-history-time-period-mode">
            <div class="mm-learning-progress-history-time-period-modes">
                <div
                    class="mm-learning-progress-history-time-period-mode-element mm-learning-progress-history-time-period-mode-element-left"
                    [class.mm-learning-progress-history-time-period-mode-element-active]="timePeriodMode === TimePeriodMode.Daily"
                    (click)="setTimePeriod(TimePeriodMode.Daily)">
                    {{ 'learningGoal.insightsPopup.learningProgressHistory.dailyMode' | translate }}
                </div>
                <div
                    class="mm-learning-progress-history-time-period-mode-element"
                    [class.mm-learning-progress-history-time-period-mode-element-active]="timePeriodMode === TimePeriodMode.Weekly"
                    (click)="setTimePeriod(TimePeriodMode.Weekly)">
                    {{ 'learningGoal.insightsPopup.learningProgressHistory.weeklyMode' | translate }}
                </div>
                <div
                    class="mm-learning-progress-history-time-period-mode-element mm-learning-progress-history-time-period-mode-element-right"
                    [class.mm-learning-progress-history-time-period-mode-element-active]="timePeriodMode === TimePeriodMode.Monthly"
                    (click)="setTimePeriod(TimePeriodMode.Monthly)">
                    {{ 'learningGoal.insightsPopup.learningProgressHistory.monthlyMode' | translate }}
                </div>
            </div>
            <div class="mm-learning-progress-history-time-period-modes-documentation-link">
                <mm-help-icon-link [title]="'learningGoal.insightsPopup.learningProgressHistory.helpButtonTitle' | translate"
                                   [link]="'https://taskbase.atlassian.net/wiki/spaces/Micromate/pages/1537839251/Das+Lernfortschritt-Diagramm'"></mm-help-icon-link>
            </div>

        </div>
        <div class="mm-learning-progress-history-chart">
            <div class="mm-learning-progress-history-chart-inner">

                <mm-learning-history-diagram class="mm-learning-progress-history-chart-inner-element"
                                             [inputData]="learningPackageHistoryData"></mm-learning-history-diagram>
            </div>
        </div>

        <div class="mm-lp-info" *ngIf="isAdmin && showAdminData && studyProgress !== undefined && studyProgress !== null">
            <p><strong class="mm-info-label">Forgetting
                factor:</strong> {{ formatForgettingFactor(studyProgress.forgettingFactorRawValue) }}%</p>
            <p><strong class="mm-info-label">Stability of
                memory:</strong> {{ formatStabilityOfMemory(studyProgress.stabilityOfMemory) }}</p>
            <p class="mm-info-block-last"><strong class="mm-info-label">Forgetting
                Offset:</strong> {{ daysToTime(studyProgress.forgettingOffset) }}</p>

            <p><strong [title]="timeFromNowToDate(studyProgress.pointOfForgetting)" class="mm-info-label">Point
                of forgetting:</strong> {{ studyProgress.pointOfForgetting | date:'dd.MM.YY HH:mm:ss' }}</p>
            <p><strong [title]="timeFromNowToDate(studyProgress.pointToLearn)" class="mm-info-label">Point to
                Learn:</strong> {{ studyProgress.pointToLearn | date:'dd.MM.YY HH:mm:ss' }}</p>
            <p><strong [title]="timeFromNowToDate(studyProgress.timeOfProof)" class="mm-info-label">Time of
                proof:</strong> {{ studyProgress.timeOfProof | date:'dd.MM.YY HH:mm:ss' }}</p>
        </div>
    </div>
}


